export default __webpack_public_path__ + "../staticImages/weinglas_mann-260.png";